<template>
  <div>
    <app-card :product="product" :key="product.slug" v-for="product in products"></app-card>
  </div>
</template>
<script>
import AppCard from '@/components/AppCard'
export default {
  components: { 'app-card': AppCard },
  name: 'AppList',
  props: ['products']
}
</script>



// WEBPACK FOOTER //
// src/components/AppList.vue